<div *ngIf="youtubeId"
	class="youtube-container">
	<iframe
		[title]="mediaTitleText"
		[src]="urlSafe"
		allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
		allowfullscreen
		class="video no-border"
		loading="lazy">
	</iframe>
</div>
<video
	*ngIf="animation && !youtubeId"
	muted
	playsinline
	controlsList="nofullscreen nodownload"
	onloadedmetadata="this.muted = true"
	oncanplay="play()"
	isVideo="true"
	[attr.title]="mediaTitleText"
	[attr.poster]="scene7service(image)"
	[commonLazyLoad]="scene7service(animation, false, 'animation', true)"
	[willLazyLoad]="lazyLoad">
	Your browser does not support the video tag.
</video>
